class Features {
    constructor() {
        this.init()
    }

    init () {
        this.cacheDOM()
        this.bindEvents()
    }

    cacheDOM () {

    }

    bindEvents () {
        this.adjustImageHeight()

        window.addEventListener( "resize", this.adjustImageHeight.bind( this ) )

    }

    adjustImageHeight () {
        if ( window.innerWidth <= 1024 ) {
            $( '.spotlight-features-block' ).each( function () {
                const height = parseInt( $( this ).find( '.features-container > ul' ).innerHeight() ) + 100
                $( this ).find( '.container .image-container img' ).css( 'height', `${ height }` )
            } )
        } else {
            $( '.spotlight-features-block' ).each( function () {
                $( this ).find( '.container .image-container img' ).css( 'height', 'auto' )
            } )
        }
    }

}

new Features()
